const handlers = {};

const EventService = {
  triggerEvent: (name, parameters) => {
    if (handlers.hasOwnProperty(name)) {
      Object.values(handlers[name]).forEach(callback => {
        callback(parameters);
      });
    }
  },
  onEvent: (name, callback) => {
    if (!handlers.hasOwnProperty(name)) {
      handlers[name] = {};
    }
    const handlerId = Date.now() + '' + Object.keys(handlers[name]).length;
    handlers[name][handlerId] = callback;
    return () => {
      delete handlers[name][handlerId];
    };
  }
};

export default EventService;
